import ObtainFeatureFlagsSecureAPIKey from "../../../../contents/docs/integrate/_snippets/obtain-flags-secure-key.mdx";
import ConfigureFlagsSecureKey from "../../../../contents/docs/integrate/_snippets/configure-flags-secure-key.mdx";
import * as React from 'react';
export default {
  ObtainFeatureFlagsSecureAPIKey,
  ConfigureFlagsSecureKey,
  React
};